export const CreatorProductRanking = {
  Trending: "trending", // used by trending products carousel
  Recent: "recent", // would be used for default Recent Products, but instead we're using Activity Service
  Relevant: "relevant", // used for Recent Products when a search query is present
} as const;
